import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Counter from '../counter/Counter'
import StepButton from '../step-button/StepButton'

import instruction from './instruction.png'

class WelcomeScreen extends Component {
  
  handleStorageClean = () => {
    localStorage.setItem('postcard', JSON.stringify({
      "gender": 1,
      "type": 1,
      "text": 1,
      "startPhrase": "",
      "name": "",
      "background": 1,
      "thumb_path": "",
      "short_link": "",
      "origin_image": ""      
    }))
  }

  render() {
    const { postcardsCount } = this.props

    return (
      <div>
        <h1 className="blue">В предновогодней суете легко закрутиться и забыть поздравить дорогих сердцу людей</h1>
        <p>Мы всё предусмотрели заранее, и предлагаем тебе создать замечательную открытку за три простых шага:</p>
        <img role="presentation" className="instruction" src={instruction} />
        <p>В результате ты получишь поздравление с морозным кузбасским характером, крепким привкусом кедровой настойки и лёгким налётом угольной пыли. Пользуйся на здоровье!</p>
        <Link to="/about" className="about-link">Подробнее о проекте</Link><br/>
        <Counter num={postcardsCount} />

        <StepButton title="Создать открытку" onNavigate={this.handleStorageClean} navigateTo="settings"/>
      </div>
    );
  }
}

export default connect((state) => ({
  postcardsCount: state.staticContent.data.postcardsCount
}))(WelcomeScreen)



// WEBPACK FOOTER //
// ./src/components/postcard/WelcomeScreen.js